export const getMarlboroughData = () => ({
  name: "Marlborough",
  country: "Nouvelle-Zélande",
  description: "Marlborough est la plus grande région viticole de Nouvelle-Zélande, réputée mondialement pour ses vins de Sauvignon Blanc élégants et aromatiques. Située à l'extrémité nord de l'île du Sud, la région bénéficie d'un climat maritime unique avec des étés chauds et secs et des nuits fraîches.",
  type: "region",
  area: "27,000 ha",
  production: "2.5 million hectolitres",
  climate: "Climat maritime avec étés chauds et secs, nuits fraîches, précipitations modérées",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat maritime avec étés chauds et secs, nuits fraîches, précipitations modérées",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Innovation technologique, viticulture durable, rendements contrôlés"
  },
  wineStyles: {
    white: "Sauvignon Blanc aromatique avec notes de fruits de la passion, agrumes et herbes",
    red: "Pinot Noir élégant avec tanins fins et notes de fruits rouges",
    rosé: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Marlborough a commencé dans les années 1970 avec les premiers vignobles commerciaux. Le Sauvignon Blanc est rapidement devenu le cépage emblématique de la région, produisant des vins avec une personnalité unique reconnue mondialement. Aujourd'hui, Marlborough est la plus importante région viticole de Nouvelle-Zélande.",
  foodPairing: "Fruits de mer, poissons blancs, salades fraîches, fromages de chèvre, cuisine asiatique",
  subregions: {
    "Wairau Valley": {
      name: "Wairau Valley",
      description: "Vallée principale de Marlborough, cœur de la production de Sauvignon Blanc",
      area: "15,000 ha",
      characteristics: "Sols alluviaux, climat maritime, vins aromatiques",
      grapeVarieties: ["sauvignon-blanc", "pinot-noir", "chardonnay", "pinot-gris"]
    },
    "Awatere Valley": {
      name: "Awatere Valley",
      description: "Vallée plus fraîche produisant des vins plus minéraux et élégants",
      area: "8,000 ha",
      characteristics: "Climat plus frais, sols calcaires, vins minéraux",
      grapeVarieties: ["sauvignon-blanc", "pinot-noir", "chardonnay"]
    },
    "Southern Valleys": {
      name: "Southern Valleys",
      description: "Vallées méridionales spécialisées dans le Pinot Noir",
      area: "4,000 ha",
      characteristics: "Sols argileux, microclimats, vins rouges de qualité",
      grapeVarieties: ["pinot-noir", "sauvignon-blanc", "chardonnay"]
    }
  },
  grapeVarieties: [
    {
      name: "Sauvignon Blanc",
      percentage: "75%",
      description: "Cépage emblématique de Marlborough, produisant des vins aromatiques avec des notes de fruits de la passion, agrumes et herbes",
      characteristics: "Aromatique, acidité vive, notes tropicales",
      wineStyles: "Sec, frais, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "15%",
      description: "Cépage rouge principal, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Chardonnay",
      percentage: "5%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "3%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Autres",
      percentage: "2%",
      description: "Autres cépages incluant Riesling, Gewürztraminer et cépages rouges",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Wairau Valley", x: 173.8, y: -41.5, color: "#4B164C", size: 6 },
    { region: "Awatere Valley", x: 174.0, y: -41.8, color: "#6d2c7a", size: 4 },
    { region: "Southern Valleys", x: 173.6, y: -41.7, color: "#8a4a8a", size: 3 }
  ]
}); 